import { render, staticRenderFns } from "./Habilitar.vue?vue&type=template&id=21b0c179&"
import script from "./Habilitar.vue?vue&type=script&lang=js&"
export * from "./Habilitar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports